<template>
  <v-layout
    row
    wrap
  >
    <v-flex>
      <v-card class="max-shadow">
        <v-card-title class="pa-2">
          <v-toolbar
            flat
            color="white"
            height="48"
          >
            <v-spacer />
            <v-toolbar-items>
              <search-widget
                v-model="search" 
              />
              <v-btn
                to="/max-admin/fnb/add-vendor"
                color="primary"
                flat
              >
                Add Vendor
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
        </v-card-title>
        <v-data-table
          :headers="vendorsHeaders"
          :items="vendors"
          :search="search"
          :loading="vendorsDataLoading"
          :no-results-text="'Your search for ' + search + ' found no results.'"
          class="px-2 pb-2"
          item-key="id"
          no-data-text="No vendor is added"
          hide-actions
          disable-initial-sort
        >
          <template
            slot="items"
            slot-scope="props"
          >
            <tr @click="$router.push('/max-admin/fnb/vendors/' + props.item.id)">
              <td>{{ props.index + 1 }}</td>
              <td class="text-xs-left">
                {{ props.item.vendorName }}
              </td>
              <td class="text-xs-left">
                {{ props.item.admin.name }}
              </td>
              <td class="text-xs-left">
                {{ formatTime(props.item.joinDate) }}
              </td>
              <td class="text-xs-left px-0">
                <v-btn
                  color="primary"
                  text
                  small
                  @click.stop="resendInvite(props.item)"
                >
                  resend invite
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card>
    </v-flex>
    <v-dialog
      v-model="resendInviteDialog"
      max-width="700px"
      persistent
    >
      <v-card>
        <v-card-title primary-title>
          <div class="headline">
            Resent invite
          </div>
        </v-card-title>
        <v-card-text>
          <div class="subtitle-1">
            Do you want to resend the invite for
            <strong>{{ selectedEmployee.id ? selectedEmployee.email : vendors.length }}</strong>
            {{ vendors.length === 1 ? '?' : 'vendors?' }}
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            color="secondary"
            @click.stop="resendInviteDialog = false"
          >
            no
          </v-btn>
          <v-btn
            depressed
            color="primary"
            :loading="resendingInvite"
            @click.stop="confirmResendInvite(selectedEmployee.id)"
          >
            yes
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="snackbar"
      :color="snackbarColor"
      :timeout="3000"
      top-right
      pb-2
    >
      {{ snackbarMessage }}
      <v-btn
        flat
        @click.native="snackbar = false"
      >
        Close
      </v-btn>
    </v-snackbar>
  </v-layout>
</template>

<script>
import * as moment from 'moment';
import { cloneDeep } from 'lodash';
import SearchWidget from '@/components/common/SearchWidget';
import { firestore, auth } from '@/firebase';

import { settings } from '../../../utils/settings';
import axios from 'axios';

export default {
  name: 'Vendors',
  components: {
    'search-widget': SearchWidget
  },
  data() {
    return {
      vendors: [],
      vendorsHeaders: [
        {
          text: '#',
          value: false,
          align: 'left'
        },
        {
          text: 'Vendor Name',
          value: 'vendorName',
          align: 'left'
        },
        {
          text: 'Admin Name',
          value: 'admin.name',
          align: 'left'
        },
        {
          text: 'Join Date',
          value: 'joinDate',
          align: 'left'
        },
        {
          text: 'Invite',
          value: 'invite',
          align: 'left'
        }
      ],
      search: '',
      vendorsDataLoading: true,
      firebaseListeners: [],
      resendingInvite: false,
      selectedEmployee: {},
      resendInviteDialog: false,
      snackbar: false,
      snackbarMessage: '',
      snackbarColor: 'success'
    };
  },
  created() {
    this.$store.commit('setToolbarTitle', { toolbarTitle: 'Vendors' });
    this.vendorsListener();
  },
  beforeDestroy() {
    // unsubscribe all firebase listeners
    this.firebaseListeners.forEach(listenerFunc => {
      listenerFunc();
    });
  },
  methods: {
    vendorsListener() {
      const vendorsListener = firestore
        .collection('vendors')
        .where('facility', '==', 'fnb')
        .onSnapshot(vendorsSnapshot => {
          //hide loading indicator if its running
          this.vendorsDataLoading = false;
          this.vendors = [];
          vendorsSnapshot.forEach(vendorsnapshot => {
            const vendor = vendorsnapshot.data();
            vendor.id = vendorsnapshot.id;
            // convert firebase timestamp to date object
            vendor.joinDate = vendorsnapshot.get('joinDate').toDate();
            this.vendors.push(vendor);
          });
        });
      this.firebaseListeners.push(vendorsListener);
    },

    formatTime(time) {
      return moment(time).format('DD MMM YYYY hh:mm A');
    },

    resendInvite(emp) {
      this.resendInviteDialog = true;
      this.selectedEmployee = cloneDeep(emp);
    },

    getIdToken() {
      return auth.currentUser.getIdToken(true);
    },

    async resendInviteRequest(eid) {
      const idToken = await this.getIdToken();
      // console.log(idToken);
      return axios.post(
        `${settings.dashboard_url}/api/fnb/vendor/invite/resend`,
        {
          vid: eid
        },
        {
          headers: {
            Authorization: `idToken ${idToken}`,
          },
        }
      );
    },

    async confirmResendInvite(eid) {
      this.resendingInvite = true;
      const promises = [];

      if (!eid) {
        this.vendors.forEach(emp => {
          if (emp.id != this.$store.state.profile.uid) promises.push(this.resendInviteRequest(emp.id));
        });
      } else {
        promises.push(this.resendInviteRequest(eid));
      }

      try {
        await Promise.all(promises);
        this.showSnackbar('Resend invitation sent successfully');
      } catch (error) {
        console.log(error);
        this.showSnackbar(error, true);
      } finally {
        this.resendingInvite = false;
        this.resendInviteDialog = false;
        this.selectedEmployee = {};
      }
    },
    
    showSnackbar(message, error) {
      // const snackbar = {
      //   message: `${message}`,
      //   color: error ? 'error' : 'success',
      //   show: true,
      // };
      this.snackbar = true;
      this.snackbarMessage = `${message}`;
      this.snackbarColor = error ? 'error' : 'success';
    },
  }
};
</script>

<style scoped></style>
